export default "__VITE_ASSET__DqfrktQV__"